import { EmploymentTypesEnum } from '../types';

export const applicantDetailsQuestions = {
  employmentType: {
    titleKey: 'affordabilityCalculator.applicantDetails.employmentType',
    placeholderKey: 'placeholders.selectOption',
    options: [
      {
        label: 'PAYE Employed',
        value: EmploymentTypesEnum.payeEmployed,
      },
      {
        label: 'Salaried director',
        value: EmploymentTypesEnum.salariedDirector,
      },
      {
        label: 'Sole trader',
        value: EmploymentTypesEnum.soleTrader,
      },
      {
        label: 'Contractor',
        value: EmploymentTypesEnum.contractor,
      },
      {
        label: 'Partnership',
        value: EmploymentTypesEnum.partnership,
      },
      { label: 'Retired', value: EmploymentTypesEnum.retired },
      {
        label: 'Unemployed',
        value: EmploymentTypesEnum.unemployed,
      },
    ],
  },
  secondIncome: {
    titleKey: 'affordabilityCalculator.applicantDetails.isSecondIncome.title',
    options: [
      {
        labelKey: 'common.yes',
        value: 'yes',
      },
      {
        labelKey: 'common.no',
        value: 'no',
      },
    ],
  },
  error: {
    required: 'common.error.requiredField',
  },
};
